import { FC } from "react";
import { Carousel } from "react-responsive-carousel";
import { ContentCarousel } from "./Content/Content";
import { MenuPage } from "../../utils/pagesData";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import styles from "./CarouselBlock.module.scss";

interface CarouselBlockProps {
  data: MenuPage;
  page: "home" | "bar";
}

export const CarouselBlock: FC<CarouselBlockProps> = ({ data, page }) => {
  return (
    <div className={styles.swWrap}>
      {/* <img src={vectorImg} draggable={false} className={styles.vector} /> */}
      <div className={styles.logoContainer}>
        <img src={data.icon} draggable={false} className={styles.logo} />
      </div>
      <div className={styles.sw}>
        {data.carousel.length > 0 && (
          <Carousel
            autoPlay
            infiniteLoop
            interval={5000}
            transitionTime={300}
            // showArrows={false}
            showIndicators={false}
            showThumbs={false}
            showStatus={false}
            swipeable={true}
          >
            {data.carousel.map((i, ind) => {
              return (
                <div key={ind} className={styles.card}>
                  <div className={styles.back} />
                  <ContentCarousel page={page} info={i} icon={data.icon} />
                  <img src={i.image} draggable={false} className={styles.img} />
                </div>
              );
            })}
          </Carousel>
        )}
      </div>
    </div>
  );
};
